export default class AuthAPIs {
  constructor(_api) {
    this.api = _api;
  }

  /**
   * Register a new user
   * @param {Object} userData - { email, password, full_name, phone, user_role }
   * @returns {Promise} User data and token (includes profile_completed)
   */
  register = (userData) => {
    return this.api.post("/auth/register", userData);
  };

  /**
   * Login user
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise} User data and token
   */
  login = (email, password) => {
    return this.api.post("/auth/login", { email, password });
  };

  /**
   * Logout user
   * @returns {Promise} Logout response
   */
  logout = () => {
    return this.api.post("/auth/logout");
  };

  /**
   * Check if token is valid
   * @returns {Promise} Token validity and user data
   */
  checkToken = () => {
    return this.api.get("/auth/check");
  };

  /**
   * Get current user profile
   * @returns {Promise} User data
   */
  getCurrentUser = () => {
    return this.api.get("/user/me");
  };

  /**
   * Update user profile
   * @param {Object} profileData - { full_name, phone, user_role }
   * @returns {Promise} Updated user data (includes profile_completed)
   */
  updateProfile = (profileData) => {
    return this.api.put("/user/profile", profileData);
  };

  /**
   * Change user password
   * @param {string} currentPassword - Current password
   * @param {string} newPassword - New password
   * @returns {Promise} Success message
   */
  changePassword = (currentPassword, newPassword) => {
    return this.api.post("/user/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
  };
}
